import { Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { TreatmentFilterModel } from '../models/superbit-api-models'
import { CustomerCardModel } from '../models/CustomerCardModel';
import { ProductionModel } from '../models/ProductionModel';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { SimulatorModel } from '../models/SimulatorModel';
import Treatments from '../treatments/_Treatments'
import { GeneralDataModel } from '../models/GeneralDataModel';
import { ManulApiModel } from '../models/ManulApiModel';
import SignMessagePopUp from './_SignMessagePopUp';
import './_SigningDetails.css';
import { FileProtectOutlined } from '@ant-design/icons';
import ProtectionModel from '../components/ProtectionModel';
import SignDocuments from './_SignDocuments';
import { cloneDeep, set } from 'lodash';
import SigningPopUpDocument from './_SigningPopUpDocument';
import ErrorMessages from '../components/ErrorMessages';

type Props = {
    customerId: string;
    tabData: any;
    config: any;
    setLoading: Function;
    updateEditData: Function;
    updatePolicy: Function;
    onFileDelete: Function;
    onAddTreatment: Function;
    onAddSubscriber: Function;
    updateMode: Function;
    addSigningComment: Function;
    TreatmentPolicy: string;
    TreatmentPop: boolean;
    loadTreatments: number;
    closeTab: Function;
    onNewOrEditTreatment: Function;
    statuses: any[];
    actionBtns: boolean;
};


const SigningDetails = (props: Props) => {
    const generalModel: GeneralDataModel = new GeneralDataModel();
    const simulatorModel: SimulatorModel = new SimulatorModel();
    const manulApiModel: ManulApiModel = new ManulApiModel();
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [itemData, setItemData] = useState<any>({});

    const [signingData, setSigningData] = useState<any>({});
    const [signingDataOld, setSigningDataOld] = useState<any>({});

    const [customer, setCustomer] = useState<any | null>(null)
    const [customerPhone, setCustomerPhone] = useState<any | null>(null)
    const [customerEmail, setCustomerEmail] = useState<any | null>(null)
    const [customerAdditionalPhone, setCustomerAdditionalPhone] = useState<any | null>(null)
    const [gender, setGender] = useState<string>('');
    const [address, setAddress] = useState<any>({});
    const [status, setStatus] = useState<string>('');
    const [statusId, setStatusId] = useState<string>('0');
    const [productionCheck, setProductionCheck] = useState<boolean>(false);
    const [collectionCheck, setCollectionCheck] = useState<boolean>(false);
    const [documentsCheck, setDocumentsCheck] = useState<boolean>(false);
    const [lackOfClaimsCheck, setLackOfClaimsCheck] = useState<boolean>(false);
    const [protectionCheck, setProtectionCheck] = useState<boolean>(false);
    const [sendingToCustomerCheck, setSendingToCustomerCheck] = useState<boolean>(false);

    const [documentsList, setDocumentsList] = useState<any[]>([]);

    const [driversType, setDriversType] = useState<string>('')
    const [vehicleOwnership, setVehicleOwnership] = useState<string>('');

    const [policyNumber, setPolicyNumber] = useState<string>('');
    const [premiumSum, setPremiumSum] = useState<number>(0);
    const [premiumSumOrg, setPremiumSumOrg] = useState<number>(0);
    const [policyStatuses, setPolicyStatuses] = useState<any[]>([]);

    const [selectedDocument, setSelectedDocument] = useState<any | null>(null);
    const [insuranceTypes, setInsuranceTypes] = useState<any[]>([]);
    const [licenseTypes, setLicenseTypes] = useState<any[]>([]);
    const [handlersList, setHandlersList] = useState<any[]>([]);
    const [gendersList, setGendersList] = useState<any[]>([]);
    const [insuranceCompanyList, setInsuranceCompanyList] = useState<any[]>([]);
    const [vehicleOwnerships, setVehicleOwnerships] = useState<any[]>([]);
    const [garages, setGarages] = useState<any[]>([]);
    const [usersOptions, setUsersOptions] = useState<any[]>([]);
    const [routeAdditionName, setRouteAdditionName] = useState<string>('');
    const [showPopUpMessage, setShowPopUpMessage] = useState<boolean>(false);
    const [popUpTitle, setPopUpTitle] = useState<string>('');

    const [errorFields, setErrorFields] = useState<any>({
        policyNumber: false,
        statusId: false,
    })
    const [showProtection, setShowProtection] = useState<boolean>(false);

    const [showErrorMessages, setShowErrorMessages] = useState<boolean>(false);
    const [messageContentPopup, setMessageContentPopup] = useState<string>('');

    const [changeComments, setChangeComments] = useState<any>({
        premiumSum: '',
        productionStep: '',
        collectionStep: '',
        protectionStep: '',
        lackOfClaimsStep: '',
        documentsStep: '',
        sendingToCustomerStep: '',
        status: '',
    });



    useEffect(() => {
        const fetchTreatments = async () => {
            if (props.TreatmentPolicy === signingData.id) {
                // refresh treatments
                const filter = new TreatmentFilterModel();
                filter.relationType = 2; // policy
                filter.relationId = signingData.id;

                signingData.treatments = await customerCardModel.treatmentsFilter(filter);
                // If you need to trigger a rerender, use state setter instead of mutating signingData
                // setSigningData({ ...signingData, treatments: await customerCardModel.treatmentsFilter(filter) });
            }
        };

        fetchTreatments();
    }, [props.TreatmentPop, props.TreatmentPolicy, signingData.id]);

    useEffect(() => {
        saveScreenMode();
    }, [signingData]);


    const saveScreenMode = () => {
        sessionStorage.setItem(signingData.id, JSON.stringify(signingData));
    }

    const removeScreenMode = () => {
        sessionStorage.removeItem(signingData.id);

    }

    const getDiscount = (discount: any) => {
        if (discount.discount.selectValue) {
            const jsonStr = discount.discount.selectValue
                .replace(/=/g, ':')              // replace = with :
                .replace(/([{,])(\w+):/g, '$1"$2":') // add quotes around keys
                .replace(/:"([^"]*?)"/g, ':"$1"');   // ensure string values are quoted

            // Parse to JSON
            const arr = JSON.parse(jsonStr);

            // Example: find label by value
            const valueToFind = discount.sum;
            const found = arr.find((item: any) => item.value === valueToFind);
            if (found)
                return found.label;

        }
        return discount.sum + "%";
    }
    const init = async () => {
        const insuranceTypesList: any[] = [];
        const insuranceTypesData = await generalModel.getAppDictionaryListExpanded();
        const itTempDataKeys = Object.keys(insuranceTypesData);
        itTempDataKeys.forEach((k: string) => {
            insuranceTypesList.push({
                value: insuranceTypesData[k].id,
                label: insuranceTypesData[k].description,
                id: insuranceTypesData[k].id,
                name: insuranceTypesData[k].description,
            })
        });
        setInsuranceTypes(insuranceTypesList);

        const licenseTypesList: any[] = [];
        const licenseTypesData = await generalModel.getLicenseTypes();
        console.log('licenseTypesData', licenseTypesData)
        const ltTempDataKeys = Object.keys(licenseTypesData);
        ltTempDataKeys.forEach((k: string) => {
            licenseTypesList.push({
                value: licenseTypesData[k].id,
                label: licenseTypesData[k].description,
            })
        });

        setLicenseTypes(licenseTypesList);


        const handlersData = await generalModel.getClaimHandlers();
        if (handlersData) {
            setHandlersList(handlersData.map((h: any) => {
                return {
                    label: h.fullName,
                    value: h.id
                }
            }))
        }

        simulatorModel.getGenderTypes().then((res: any) => {
            const gendersList: any = [];
            Object.keys(res).forEach((key: string) => {
                const gender = res[key];
                gendersList.push({
                    label: gender.description,
                    value: gender.id.toString()
                })
            })
            setGendersList(gendersList);
        });

        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name,
                id: insuranceCompaniesData[k].description,
                name: insuranceCompaniesData[k].name,
            })
        });
        fixedInsuranceCompanies.sort((a: any, b: any) => (a.label > b.label) ? 1 : -1)
        setInsuranceCompanyList(fixedInsuranceCompanies);


        const garagesListString = localStorage.getItem('garagesData');
        if (!garagesListString) {
            try {
                const garagesData: any[] = await manulApiModel.GetGarages();
                console.log('init-garagesData await manulApiModel.GetGarages', garagesData)
                if (garagesData) {
                    let moshahList: any[] = [];
                    moshahList = garagesData.map((g: any) => {
                        return {
                            shem_mosah: g.shem_mosah,
                            id: g._id,
                            cod_miktzoa: g.cod_miktzoa,
                            cod_sug_mosah: g.cod_sug_mosah,
                            ktovet: g.ktovet,
                            menahel_miktzoa: g.menahel_miktzoa,
                            miktzoa: g.miktzoa,
                            mikud: g.mikud,
                            mispar_mosah: g.mispar_mosah,
                            rasham_havarot: g.rasham_havarot,
                            sug_mosah: g.sug_mosah,
                            telephone: g.telephone,
                            yishuv: g.yishuv
                        }
                    });
                    setGarages([...garagesData]);
                    localStorage.setItem('garagesData', JSON.stringify(moshahList));
                }
            } catch (error) {

            }
        } else {

            const garagesData = JSON.parse(garagesListString);
            setGarages(garagesData);
            // console.log('garagesData', garagesData);
        }

        const vehicleOwnershipList: any[] = [];
        const vehicleOwnershipData = await simulatorModel.getVehicleOwnership();
        const sTempDataKeys = Object.keys(vehicleOwnershipData);
        sTempDataKeys.forEach((k: string) => {
            vehicleOwnershipList.push({
                value: vehicleOwnershipData[k].id,
                label: vehicleOwnershipData[k].description,
                id: vehicleOwnershipData[k].id,
                name: vehicleOwnershipData[k].description,
            })
        });
        setVehicleOwnerships(vehicleOwnershipList);

        const usersData = await generalModel.customerCardGetCreators();
        setUsersOptions(usersData);
    }

    const onUpdate = (newData: any) => {
        if (props.updateEditData) {
            props.updateEditData(newData)

            Object.entries(changeComments).forEach(([key, value]) => {
                console.log(`${key}: ${value}`);
                if (value && typeof value === 'string' && value.length > 0) {

                    addSigningComment(value as string);
                }
            });

        }
    }

    const saveDetails = async (e: any) => {

        const currentData = signingData;

        if (signingDataOld.elementaryPolicyStatusId !== signingData.elementaryPolicyStatusId) {

            if (policyStatuses) {
                let prevStatus = policyStatuses.find((s: any) => s.value === signingDataOld.elementaryPolicyStatusId);
                if (!prevStatus) {
                    prevStatus = {
                        value: 0,
                        label: 'חדש'
                    }
                }

                let newStatus = policyStatuses.find((s: any) => s.value === signingData.elementaryPolicyStatusId);
                if (!newStatus) {
                    newStatus = {
                        value: 0,
                        label: 'חדש'
                    }
                }


                const comment = `סטטוס שונה מ- ${prevStatus.label} ל-${newStatus.label}`;
                console.log('onStatusChange-comment', comment)
                let changeCommentsTemp = changeComments;
                changeCommentsTemp.status = comment;
                setChangeComments(changeCommentsTemp);
            }
        }



        if (currentData.elementaryPolicyStatusId == "4417fea8-6401-4125-97fc-d3281bb79306"
            && (currentData.policy.policyNumber == null || currentData.policy.policyNumber.length == 0)) {
            const newErrorFields = { ...errorFields, policyNumber: true };
            setErrorFields(newErrorFields);
            setShowErrorMessages(true);
            setPopUpTitle('שגיאה');
            setMessageContentPopup('יש למלא את שדה מספר פוליסה לפני שמירה');
            return;
        }
        await onUpdate(currentData);
        closeWithoutSave(e);
    }

    const onAddSubscriber = () => {
        if (props.onAddSubscriber) {
            props.onAddSubscriber(customer, signingData.vehicle);
            console.log('onAddSubscriber');
        }
    }

    const calcAge = (dateOfBirth: Date, startDate: Date) => {

        var diff_ms = new Date(startDate).getTime() - new Date(dateOfBirth).getTime();

        var age_dt = new Date(diff_ms);
        var age = Math.abs(age_dt.getUTCFullYear() - 1970);
        return age;
    }

    const getAge = (birthDate: Date) => {
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();

        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }


    const onPolicyNumberChange = async (event: any) => {
        const newPolicyNumber = event.target.value;
        const currentData = signingData;
        setPolicyNumber(newPolicyNumber);
        currentData.policy.policyNumber = newPolicyNumber;
        //await setSigningData(currentData);
        setSigningData((prev: any) => ({
            ...prev,
            policy: {
                ...prev.policy,
                policyNumber: newPolicyNumber
            }
        }));
        //onUpdate(currentData);
    };

    const onPremiumSum = async (event: any) => {

        const premiumSum = event.target.value;
        const currentData = signingData;
        setPremiumSum(Number(premiumSum));
        currentData.premiumSum = Number(premiumSum);

        await setSigningData((prev: any) => ({
            ...prev,
            premiumSum: premiumSum
        }));
        //await onUpdate(currentData);
    };


    const savePremiumSum = async (event: any) => {
        if (premiumSum != premiumSumOrg) {
            const comment = `מחיר פרמיה שונה מ- ${premiumSumOrg} ל-${premiumSum}`;
            let changeCommentsTemp = changeComments;
            changeCommentsTemp.premiumSum = comment;
            setChangeComments(changeCommentsTemp);
            setPremiumSumOrg(premiumSum);
        }
    };

    const onStatusChange = async (value: string) => {
        console.log('onStatusChange', value);
        const currentData = signingData;
        setStatusId(value);




        if (policyStatuses) {
            // let prevStatus = policyStatuses.find((s: any) => s.value === currentData.elementaryPolicyStatusId);
            // if (!prevStatus) {
            //     prevStatus = {
            //         value: 0,
            //         label: 'חדש'
            //     }
            // }
            // let newStatus = policyStatuses.find((s: any) => s.value === value);
            // if (!newStatus) {
            //     newStatus = {
            //         value: 0,
            //         label: 'חדש'
            //     }
            // }
            // console.log('onStatusChange prevStatus', prevStatus, 'newStatus', newStatus)
            // const comment = `סטטוס שונה מ- ${prevStatus.label} ל-${newStatus.label}`;
            // console.log('onStatusChange-comment', comment)
            // let changeCommentsTemp = changeComments;
            // changeCommentsTemp.status = comment;
            // setChangeComments(changeCommentsTemp);
            // setChangeComments([...changeComments, comment]);
            // addSigningComment(comment);
            currentData.elementaryPolicyStatusId = value;
            await setSigningData(currentData);
            //onUpdate(currentData);
        }

    }

    const handleCheckChange = async (name: string, event: any) => {
        console.log('handleCheckChange');
        const currentData = signingData;
        const currentValue: boolean = currentData[name] ? true : false
        var newVal = !currentValue;
        let comment = '';
        comment += ` ${newVal ? 'סומן ' : 'בוטל '}`;

        switch (name) {
            case 'productionStep':
                setProductionCheck(!currentValue);
                comment += `הפקה`;
                break;
            case 'collectionStep':
                setCollectionCheck(!currentValue);
                comment += `גביה`;
                break;
            case 'protectionStep':
                setProtectionCheck(!currentValue);
                comment += `מיגון`;
                break;
            case 'lackOfClaimsStep':
                setLackOfClaimsCheck(!currentValue);
                comment += `ה. תביעות`;
                break;
            case 'documentsStep':
                setDocumentsCheck(!currentValue);
                comment += `מסמכים`;
                break;
            case 'sendingToCustomerStep':
                setSendingToCustomerCheck(!currentValue);
                comment += `שליחה`;
                break;

            default:
                break;
        }
        let changeCommentsTemp = changeComments;
        changeCommentsTemp[name] = comment;
        setChangeComments(changeCommentsTemp);

        setSigningData((prev: any) => ({
            ...prev,
            [name]: newVal
        }));

        //onUpdate(currentData);
    }

    const addSigningComment = (comment: string) => {
        if (props.addSigningComment) {
            const data = {
                "TreatmentType": 4,
                "AlertDate": moment().format('YYYY-MM-DDTHH:mm'),
                "Topic": comment,
                "PolicyRelatedId": signingData.policy.id,
                'Seen': true

            }
            props.addSigningComment(data);
        }
    }

    const onSelectDocument = (document: any) => {

        setSelectedDocument(document);
    }



    const onDoDeleteDocument = async (_document: any) => {

        await new CustomerCardModel().customerDocumentsDelete(_document.id)


        var docs = await new ProductionModel().GetSigningDocuments(signingData.policyId);

        setDocumentsList(docs);
    }

    const onCloseDocument = () => {
        setSelectedDocument(null);
    }

    const handleFileChange = async (event: any) => {

        const fileUploaded = event.target.files[0];
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }

        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = async () => {
                const data = signingData.elementaryPolicy;
                const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                if (!data.fileAttachments) {
                    data.fileAttachments = [];
                }

                const obj = {
                    file: reader.result,
                    name: fileName,
                    customerId: signingData.policy.customerId,
                    documentRelations: [{ relationId: signingData.policyId, type: 2/*policy*/ }]
                }

                const response = await new CustomerCardModel().customerDocumentsUploadFile(obj);
                if (response) {

                    // var docs = await new ProductionModel().GetSigningDocuments(signingData.id);
                    const dataAfterUpdateDocuments = await new ProductionModel().GetSigningData(props.tabData.id);
                    if (dataAfterUpdateDocuments.elementaryPolicyDocuments && dataAfterUpdateDocuments.elementaryPolicyDocuments.length > 0) {
                        setDocumentsList(dataAfterUpdateDocuments.elementaryPolicyDocuments);
                    }
                    const comment = `נוסף קובץ בשם: ${fileName}`;
                }

            }
            reader.readAsDataURL(fileUploaded);
        }
    };

    const showMessagePopup = (message: string) => {
        if (message && message.length > 0) {
            // setMessageContent(message);
        }
    }

    const closeTab = (e?: Event) => {
        setPopUpTitle('האם לשמור שינויים?');
        setShowPopUpMessage(true);
    }

    const closeWithoutSave = (e: any) => {
        props.closeTab(signingData.id, e);
        removeScreenMode()
    }

    const closeWithSave = async (e: any) => {
        await saveDetails(e);
    }

    const PrintPolicy = async (e: any) => {
        let data = await new ProductionModel().PrintPolicy(props.tabData.id);
        openPdf(data);
    }

    const openPdf = (url: string) => {
        window.open(url, "_blank");
    };

    const onChangeAdditionNumberPolicy = (value: string) => {
        console.log('onChangeAdditionNumberPolicy', value);
        // const currentData = signingData;
        // currentData.policy.additionNumber = value;
        // setSigningData(currentData);
        setSigningData((prev: any) => ({
            ...prev,
            policy: {
                ...prev.policy,
                additionNumber: value
            }
        }));
    }

    const fetchData = async () => {
        if (props.tabData) {
            const signingPageData = sessionStorage.getItem(props.tabData.id);
            let data = null;
            // if (signingPageData != null) {
            //     data = JSON.parse(signingPageData)
            //     console.log('fetchData-data from storage', data)
            // }
            // else {
            data = await new ProductionModel().GetSigningData(props.tabData.id);
            console.log('fetchData-data from server', data)
            // }
            setItemData(data);

            const signingData = data;
            setSigningData(signingData);
            setSigningDataOld(cloneDeep(signingData));

            setProductionCheck(signingData.productionStep ? signingData.productionStep : false);
            setCollectionCheck(signingData.collectionStep ? signingData.collectionStep : false);
            setDocumentsCheck(signingData.documentsStep ? signingData.documentsStep : false);
            setLackOfClaimsCheck(signingData.lackOfClaimsStep ? signingData.lackOfClaimsStep : false);
            setProtectionCheck(signingData.protectionStep ? signingData.protectionStep : false);

            setRouteAdditionName(data.elementaryPolicy && data.elementaryPolicy.offer.additionalDetails && data.elementaryPolicy.offer.additionalDetails.indexOf('coverage10000\':true') != -1 ? ' 10000' : "");
            setSendingToCustomerCheck(signingData.sendingToCustomerStep ? signingData.sendingToCustomerStep : false);

            const policyData = signingData.policy;
            setPolicyNumber(policyData.policyNumber);
            setPremiumSum(signingData.premiumSum);
            setPremiumSumOrg(signingData.premiumSum);

            const vehicleData = signingData.vehicle;
            const customerData = policyData.customer;
            const ownerCustomer = policyData.customer;

            setCustomer(ownerCustomer);

            if (ownerCustomer && ownerCustomer.customerContactDetails && ownerCustomer.customerContactDetails.length > 0) {
                setCustomerPhone(ownerCustomer.customerContactDetails[0].number);
                setCustomerEmail(ownerCustomer.customerContactDetails[0].emailAddress);

                setCustomerAdditionalPhone(ownerCustomer.customerContactDetails[1] ? ownerCustomer.customerContactDetails[1].number : '');
            } else {
                setCustomerPhone('');
                setCustomerEmail('');
                setCustomerAdditionalPhone('');
            }

            const gendersList = await new SimulatorModel().getGenderTypes();

            if (customerData && customerData.gender !== undefined) {
                const selectedGender = gendersList[customerData.gender];
                if (selectedGender) setGender(selectedGender.description);
            }

            if (customerData && customerData.customerAddresses && customerData.customerAddresses.length > 0) {
                setAddress(customerData.customerAddresses[0]);
            }

            const policyStatusesData = await new OfferProductionModel().getPolicyStatuses();
            await setPolicyStatuses(policyStatusesData.map((ps: any) => {
                return {
                    label: ps.name,
                    value: ps.id.toString()
                }
            }))


            if (signingData.elementaryPolicyStatusId) {
                setStatusId(signingData.elementaryPolicyStatusId);
                const selectedStatus = policyStatuses.find(
                    (s: any) => s.value === signingData.elementaryPolicyStatusId
                );
                if (selectedStatus) setStatus(selectedStatus.label);
            }

            if (signingData.elementaryPolicy && signingData.elementaryPolicyDocuments && signingData.elementaryPolicyDocuments.length > 0) {
                setDocumentsList(signingData.elementaryPolicyDocuments);
            }

            if (vehicleData) {
                const selectedOwnership = props.tabData.vehicleOwnerships.find(
                    (vo: any) => vo.id === vehicleData.vehicleOwnership
                );
                if (selectedOwnership) setVehicleOwnership(selectedOwnership.name);
            }

            switch (signingData.driversType) {
                case 0:
                    setDriversType('נהג אחד');
                    break;
                case 1:
                    setDriversType('שני נהגים');
                    break;
                case 2:
                    setDriversType('כל נהג');
                    break;
                default:
                    break;
            }
        }

        init();
    };
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [props.tabData]);

    return (
        <>

            {
                showErrorMessages &&
                <SignMessagePopUp
                    messageTitle={popUpTitle}
                    messageContent={messageContentPopup}
                    ShowHidePopup={(status: boolean) => setShowErrorMessages(status)}
                    ClosePopup={() => setShowErrorMessages(false)}
                />
            }

            {
                showPopUpMessage &&
                <SignMessagePopUp
                    actionBtns={props.actionBtns}
                    messageTitle={popUpTitle}
                    messageContent={""}
                    ShowHidePopup={(status: boolean) => setShowPopUpMessage(status)}
                    ClosePopup={() => setShowPopUpMessage(false)}
                    OnApprove={closeWithSave}
                    onPrevious={closeWithoutSave}
                />
            }
            {selectedDocument && <SigningPopUpDocument ClosePopup={onCloseDocument} document={selectedDocument} />}
            <div className="content-body signing-details signing-details-view signing-details-view-mode">


                <div className='content-header flex-space-between'>
                    <div className='flex-space-between client-details' style={{ gap: '30px' }}>
                        <div>
                            {customer && customer.fullName}
                        </div>
                        <div>
                            <span style={{ color: 'gray' }}>טלפון:</span> {customerPhone}
                        </div>
                        <div>
                            <span style={{ color: 'gray' }}>ת.ז:</span> {customer && customer.identifier}
                        </div>
                        <div className='customer-card'>כרטיס לקוח</div>
                    </div>
                    <div className='flex-space-between action-section'>
                        <div className="icon print pointer" onClick={(e: any) => PrintPolicy(e)}></div>
                        <div className="icon excel pointer"></div>
                        <button type="button" className="button blue has-icon flex-centered flex-justify-center pointer" onClick={(e: any) => closeTab(e)}>
                            ביטול
                        </button>
                        {props.actionBtns ? <button type="button" className="button blue has-icon flex-centered flex-justify-center pointer" onClick={(e: any) => saveDetails(e)}>
                            שמירה
                        </button>
                            : <></>}
                    </div>
                </div>

                <div className='white-block'>
                    <div className="block-title">
                        סיכום הפקה
                    </div>
                    <div className="row-details">
                        <div className="item insuranse-details">
                            <div className="title">
                                סוג ביטוח
                            </div>
                            <div className="value">
                                רכב
                            </div>
                        </div>
                        <div className="item insuranse-details">
                            <div className="title">
                                חברת ביטוח
                            </div>
                            <div className="value">
                                {signingData.policy && signingData.policy.insuranceCompany ? signingData.policy.insuranceCompany.name : ""}
                            </div>
                        </div>

                        <div className="item insuranse-details-branch">
                            <div className="title">
                                ענף
                            </div>
                            <div className="value">
                                {signingData.elementaryPolicy && signingData.elementaryPolicy.insuranceCompanyRoute && signingData.elementaryPolicy.insuranceCompanyRoute.routeId}
                            </div>
                        </div>
                        <div className="item insuranse-details">
                            <div className="title">
                                מסלול
                            </div>
                            <div className="value">
                                {signingData.elementaryPolicy && signingData.elementaryPolicy.insuranceCompanyRoute && signingData.elementaryPolicy.insuranceCompanyRoute.comment}
                                {routeAdditionName}
                            </div>
                        </div>
                        <div className="item insuranse-details">
                            <div className="title">
                                ביטוח
                            </div>
                            <div className="value">

                                {signingData.vehiclePolicyType && signingData.vehiclePolicyType == 6 ? "חובה" : signingData.vehiclePolicyType == 0 ? "מקיף" : "צד ג'"}
                            </div>
                        </div>
                        <div className="item insuranse-input-policy-addition-number">
                            <div className="title">
                                מספר תוספת
                            </div>

                            <input className={`input-filed`} type='text' value={signingData?.policy?.additionNumber ? signingData.policy.additionNumber : ''}
                                onChange={(e: any) => onChangeAdditionNumberPolicy(e.target.value)} placeholder='שדה חובה' />
                        </div>
                        <div className="item insuranse-input-policy-number">
                            <div className="title">
                                מספר פוליסה
                            </div>
                            <input className={`input-filed ${errorFields.policyNumber ? 'error' : ''}`}
                                type='text' value={policyNumber} onChange={onPolicyNumberChange} placeholder='שדה חובה' />
                        </div>
                        <div className="item insuranse-details-payments">
                            <div className="title">
                                תשלומים
                            </div>
                            <div className="value">
                                {signingData.numberOfPayments}
                            </div>
                        </div>
                        <div className="item insuranse-input-premia">
                            <div className="title">
                                פרמיה
                            </div>
                            <input className={`input-filed`} type='text' value={premiumSum} onChange={onPremiumSum} onBlur={savePremiumSum} />
                        </div>

                        <div className="item checkbox-details">
                            <div className="title">
                                הפקה
                            </div>
                            <div className="value">
                                <input type='checkbox' checked={productionCheck} onChange={(e: any) => handleCheckChange('productionStep', e)} />
                            </div>
                        </div>
                        <div className="item checkbox-details">
                            <div className="title">
                                גביה
                            </div>
                            <div className="value">
                                <input type='checkbox' checked={collectionCheck} onChange={(e: any) => handleCheckChange('collectionStep', e)} />
                            </div>
                        </div>
                        <div className="item checkbox-details">
                            <div className="title">
                                מיגון
                            </div>
                            <div className="value">
                                <input type='checkbox' checked={protectionCheck} onChange={(e: any) => handleCheckChange('protectionStep', e)} />
                            </div>
                        </div>
                        <div className="item checkbox-details">
                            <div className="title">
                                ה. תביעות
                            </div>
                            <div className="value">
                                <input type='checkbox' checked={lackOfClaimsCheck} onChange={(e: any) => handleCheckChange('lackOfClaimsStep', e)} />
                            </div>
                        </div>
                        <div className="item checkbox-details">
                            <div className="field">
                                <div className="title">
                                    מסמכים
                                </div>
                                <div className="value">
                                    <input type='checkbox' checked={documentsCheck} onChange={(e: any) => handleCheckChange('documentsStep', e)} />
                                </div>
                            </div>
                        </div>
                        <div className="item checkbox-details">
                            <div className="title">
                                שליחה
                            </div>
                            <div className="value">
                                <input type='checkbox' checked={sendingToCustomerCheck} onChange={(e: any) => handleCheckChange('sendingToCustomerStep', e)} />
                            </div>
                        </div>
                        <div className="item status-details">
                            <div className="title">
                                סטטוס
                            </div>
                            <div className="value">
                                <Select
                                    value={statusId}
                                    style={{ width: '100%' }}
                                    options={[
                                        {
                                            label: 'חדש',
                                            value: '0'
                                        },
                                        ...props.statuses]}
                                    onChange={onStatusChange}
                                />
                            </div>
                        </div>

                    </div>
                    {signingData.vehiclePolicyType != 6 ?
                        <><div className="block-title">
                            הנחות

                        </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם
                                        </div>
                                        <div className="value">
                                            הנחת חובה

                                        </div>
                                    </div>


                                </div>

                                {signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.offer && signingData.elementaryPolicy.offer.discounts ? signingData.elementaryPolicy.offer.discounts.map((discount: any) => {
                                    return (
                                        <>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        שם
                                                    </div>
                                                    <div className="value">
                                                        {discount.discount.name}

                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                signingData.route && signingData.route.insuranceCompanyId == "1c9bc612-82bb-4695-b8c9-94d858dc745a"/*איילון*/ ?
                                                    <>
                                                        <div className="parameter-item">
                                                            <div className="field">
                                                                <div className="title">
                                                                    אחוז ההנחה התאמה
                                                                </div>
                                                                <div className="value">
                                                                    {discount.ayalonHanachatHatama}%

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="parameter-item">
                                                            <div className="field">
                                                                <div className="title">
                                                                    אחוז ההנחה סוכן
                                                                </div>
                                                                <div className="value">
                                                                    {discount.ayalonHanachatSochen}%

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="parameter-item">
                                                        <div className="field">
                                                            <div className="title">
                                                                אחוז ההנחה
                                                            </div>
                                                            <div className="value">
                                                                {getDiscount(discount)}
                                                                {/* {discount.sum}% */}

                                                            </div>
                                                        </div>
                                                    </div>
                                            }
                                        </>
                                    )
                                }) : ""}
                            </div>
                        </>
                        : ""}

                    <div className="parameter-row single-item">
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    הערות
                                </div>
                                <div className="value value-with-border">
                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.comment}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='signing-details-bottom-part'>
                    <div className='signing-details-right-side'>
                        <div className='white-block'>
                            <div className="block-title">
                                טופס הצעה
                            </div>
                            <section className='with-top-border'>
                                <div className='section-title'>
                                    כללי
                                </div>

                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                שם מבוטח
                                            </div>
                                            <div className="value">
                                                {customer && customer.firstName + " " + customer.lastName}
                                            </div>
                                        </div>
                                        <div className="field">
                                            <div className="title">
                                                ת.ז.                                        </div>
                                            <div className="value">
                                                {customer && customer.identifier}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                תאריך לידה
                                            </div>
                                            <div className="value">
                                                {customer && moment(customer.dateOfBirth).format('DD-MM-YYYY')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                כתובת
                                            </div>
                                            <div className="value">
                                                {address.street} {address.houseNumber}{address.apartmentNumber > 0 ? "/" + address.apartmentNumber : ""}, {address.city}, {address.postalCode && address.postalCode.length > 0 ? "מיקוד: " + address.postalCode : ""},
                                                {address.mailbox && address.mailbox.length > 0 ? "ת.ד.: " + address.mailbox : ""}, {address.entry && address.entry.length > 0 ? "כניסה: " + address.entry : ""}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                סוג אירוע
                                            </div>
                                            <div className="value">
                                                {signingData.eventType == 1 ? "חדש" : "חידוש"}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                ביטוח
                                            </div>
                                            <div className="value">

                                                {signingData.vehiclePolicyType != undefined && (signingData.vehiclePolicyType == 6 ? "חובה" : signingData.vehiclePolicyType == 0 ? "מקיף" : "צד ג'")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מספר פוליסה
                                            </div>
                                            <div className="value">
                                                {policyNumber}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                טלפון נייד
                                            </div>
                                            <div className="value">
                                                {customerPhone}


                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                סוג פוליסה
                                            </div>
                                            <div className="value">
                                                רכב
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                פרמיה
                                            </div>
                                            <div className="value">
                                                {signingData.premiumSum}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                חברת ביטוח
                                            </div>
                                            <div className="value">
                                                {signingData.policy && signingData.policy.insuranceCompany ? signingData.policy.insuranceCompany.name : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                ענף
                                            </div>
                                            <div className="value">
                                                {signingData.elementaryPolicy && signingData.elementaryPolicy.insuranceCompanyRoute && signingData.elementaryPolicy.insuranceCompanyRoute.routeId}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                ת. תחילה
                                            </div>
                                            <div className="value">
                                                {signingData.policy && signingData.policy.startDate && moment(signingData.policy.startDate).format('DD-MM-YYYY')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                ת. סיום
                                            </div>
                                            <div className="value">
                                                {signingData.policy && signingData.policy.endDate && moment(signingData.policy.endDate).format('DD-MM-YYYY')}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מסלול
                                            </div>
                                            <div className="value">
                                                {signingData.elementaryPolicy && signingData.elementaryPolicy.insuranceCompanyRoute && signingData.elementaryPolicy.insuranceCompanyRoute.comment}
                                                {routeAdditionName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מספר סוכן
                                            </div>
                                            <div className="value">
                                                {signingData.policy && signingData.policy.agentDetails && signingData.policy.agentDetails.agentNumber}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                חברה קודמת
                                            </div>
                                            <div className="value">
                                                {signingData.lastPolicyNumber}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                הערות
                                            </div>
                                            <div className="value">
                                                {signingData.comment}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מייל
                                            </div>
                                            <div className="value">
                                                {customerEmail}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מגדר
                                            </div>
                                            <div className="value">
                                                {gender}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className='with-top-border'>
                                <div className='section-title'>
                                    פרטי הרכב
                                </div>
                                {signingData && signingData.vehicle ? <>
                                    <div className="parameter-row">
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    מספר רישוי
                                                </div>
                                                <div className="value">
                                                    {signingData.vehicle.licenseNumber}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    שנת יצור
                                                </div>
                                                <div className="value">
                                                    {signingData.vehicle.carYear}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    מספר פוליסה
                                                </div>
                                                <div className="value">
                                                    {signingData.policyNumber}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    סוג הרכב
                                                </div>
                                                <div className="value">
                                                    {vehicleOwnership}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    משקל/נפח
                                                </div>
                                                <div className="value">
                                                    {signingData.vehicle && signingData.vehicle.vehicleWeight}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    קוד דגם
                                                </div>
                                                <div className="value">
                                                    {signingData.vehicle && signingData.vehicle.vehicleSubModel && signingData.vehicle.vehicleSubModel.modelCode}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-row">
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    דגם
                                                </div>
                                                <div className="value">
                                                    {signingData.vehicle && signingData.vehicle.vehicleSubModel && signingData.vehicle.vehicleSubModel.name}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    הנעה
                                                </div>
                                                <div className="value">
                                                    {signingData.vehicle ? <>
                                                        {signingData.vehicle.gearsType == 0 ? <>
                                                            אוטומטית
                                                        </> : <>
                                                            ידנית
                                                        </>}
                                                    </> : <></>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    מיגון נדרש
                                                </div>
                                                <div className="value" style={{ justifyContent: 'flex-start', gap: '8px' }}>
                                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.offer && signingData.elementaryPolicy.offer.protection}
                                                    <FileProtectOutlined style={{ fontSize: '28px', color: '#007cff' }} onClick={() => setShowProtection(true)} />
                                                    {
                                                        showProtection && signingData.elementaryPolicy && signingData.elementaryPolicy.offer ? (
                                                            <ProtectionModel
                                                                offer={signingData.elementaryPolicy.offer}
                                                                onClose={() => setShowProtection(false)}
                                                                right={1}
                                                            />
                                                        ) : ""
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item"></div>
                                        <div className="parameter-item"></div>
                                    </div>
                                </> : <></>
                                }
                            </section>
                            <section className='with-top-border flex-space-between'>
                                <div style={{ flexGrow: '1' }}>
                                    <div className='section-title'>
                                        פרטי נהגים
                                    </div>
                                    <div className="parameter-row">
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    רשאים לנהוג
                                                </div>
                                                <div className="value">
                                                    {driversType}
                                                </div>
                                            </div>
                                        </div>
                                        {signingData.driversType == 0 ?
                                            <>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            שם הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainFirstName && signingData.driverMainLastName ? signingData.driverMainFirstName + ' ' + signingData.driverMainLastName : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ת.ז. הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainIdentifier}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ת. לידה
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainBirthDate && moment(signingData.driverMainBirthDate).format('DD-MM-YYYY')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            גיל הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainAge ? signingData.driverMainAge : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            תאריך ה. רשיון
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainSeniorityDate && moment(signingData.driverMainSeniorityDate).format('DD-MM-YYYY')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ותק הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainSeniority}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מגדר
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainGender != null && signingData.driverMainGender == 0 ? "זכר" : "נקבה"}
                                                        </div>
                                                    </div>
                                                </div>

                                            </>
                                            : ""}
                                        {signingData.driversType == 2 && signingData.vehiclePolicyType != 6 ?
                                            <><div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        שם הנהג
                                                    </div>
                                                    <div className="value">
                                                        {/* {signingData.fullName ? signingData.fullName :""} */}
                                                    </div>
                                                </div>
                                            </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ת.ז. הנהג
                                                        </div>
                                                        <div className="value">
                                                            {/* {signingData.driverMainIdentifier} */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ת. לידה
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainBirthDate && moment(signingData.driverMainBirthDate).format('DD-MM-YYYY')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            גיל הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainAge}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            תאריך ה. רשיון
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainSeniorityDate && moment(signingData.driverMainSeniorityDate).format('DD-MM-YYYY')}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ותק הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverMainSeniority}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מגדר
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverYoungGender != null && signingData.driverYoungGender == 0 ? "זכר" : "נקבה"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            : ""}
                                        {signingData.driversType == 2 && signingData.vehiclePolicyType == 6 ?
                                            <>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ת. לידה
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverYoungBirthDate && moment(signingData.driverYoungBirthDate).format('DD-MM-YYYY')}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            גיל הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverYoungAge}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            תאריך ה. רשיון
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverYoungSeniorityDate && moment(signingData.driverYoungSeniorityDate).format('DD-MM-YYYY')}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ותק הנהג
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverYoungSeniority}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מגדר
                                                        </div>
                                                        <div className="value">
                                                            {signingData.driverYoungGender != null && signingData.driverYoungGender == 0 ? "זכר" : "נקבה"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            : ""}
                                        {signingData.driversType == 1 ? <><div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    שם הנהג העיקרי
                                                </div>
                                                <div className="value">
                                                    {signingData.driverMainFirstName + ' ' + signingData.driverMainLastName}
                                                </div>
                                            </div>
                                        </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ת.ז. הנהג העיקרי
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverMainIdentifier}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ת. לידה הנהג העיקרי
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverMainBirthDate && moment(signingData.driverMainBirthDate).format('DD-MM-YYYY')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        גיל הנהג העיקרי
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverMainAge}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ת.ה. רשיון הנהג העיקרי
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverMainSeniorityDate && moment(signingData.driverMainSeniorityDate).format('DD-MM-YYYY')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ותק הנהג העיקרי
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverMainSeniority}
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        מגדר הנהג העיקרי
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverMainGender != null && signingData.driverMainGender == 0 ? "זכר" : "נקבה"}
                                                    </div>
                                                </div>
                                            </div>
                                        </> : ""}


                                    </div>
                                    {signingData.driversType == 1 ? <>
                                        <div className="parameter-row">
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">

                                                    </div>
                                                    <div className="value">

                                                    </div>
                                                </div>
                                            </div><div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        שם הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungFirstName + ' ' + signingData.driverYoungLastName}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ת.ז. הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungIdentifier}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ת. לידה הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungBirthDate && moment(signingData.driverYoungBirthDate).format('DD-MM-YYYY')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        גיל הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungAge}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ת.ה. רשיון הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungSeniorityDate && moment(signingData.driverYoungSeniorityDate).format('DD-MM-YYYY')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        ותק הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungSeniority}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        מגדר הנהג הצעיר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.driverYoungGender != null && signingData.driverYoungGender == 0 ? "זכר" : "נקבה"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </> : ""}


                                </div>
                                {/* <div style={{minWidth:'200px'}}>
                                <div className='section-title'>
                                שרותי דרך
                                </div>
                                <div className="parameter-row single-item">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                            ספק שרותי דרך
                                            </div>
                                            <div className="value">
                                            
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div> */}
                            </section>
                            <section className='with-top-border flex-space-between'>
                                <div style={{ flexGrow: '1' }}>
                                    <div className='section-title'>
                                        עבר ביטוחי
                                    </div>
                                    <div className="parameter-row">
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    שנה אחרונה
                                                </div>
                                                <div className="value">

                                                    סוג ביטוח: {signingData.passedInsuranceTypeLastYear == 0 ? "מקיף" : signingData.passedInsuranceTypeLastYear == 1 ? "צד ג'" : "לא היה מבוטח"}, {signingData.sueNumber1 == 0 ? "ללא" : signingData.sueNumber1 + ""} תביעות

                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    לפני שנתיים
                                                </div>
                                                <div className="value">
                                                    סוג ביטוח: {signingData.passedInsuranceType2YearsAgo == 0 ? "מקיף" : signingData.passedInsuranceType2YearsAgo == 1 ? "צד ג'" : "לא היה מבוטח"}, {signingData.sueNumber2 == 0 ? "ללא" : signingData.sueNumber2 + ""} תביעות
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    לפני 3 שנים
                                                </div>
                                                <div className="value">
                                                    סוג ביטוח: {signingData.passedInsuranceType3YearsAgo == 0 ? "מקיף" : signingData.passedInsuranceType3YearsAgo == 1 ? "צד ג'" : "לא היה מבוטח"}, {signingData.sueNumber3 == 0 ? "ללא" : signingData.sueNumber3 + ""} תביעות
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    תביעות גוף
                                                </div>
                                                <div className="value">
                                                    {signingData.bodyClaimsAmount && signingData.bodyClaimsAmount > 0 ? signingData.bodyClaimsAmount : "ללא"}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    שלילות
                                                </div>
                                                <div className="value">
                                                    {signingData.revocationsAmount && signingData.revocationsAmount > 0 ? signingData.revocationsAmount : "ללא"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section className='with-top-border flex-space-between'>
                                <div style={{ flexGrow: '1' }}>
                                    <div className='section-title'>
                                        פרטים נוספים והרחבות
                                    </div>
                                    <div className="parameter-row">
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    חדש תמורת ישן
                                                </div>
                                                <div className="value">
                                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.offer && signingData.elementaryPolicy.newForOld ? <>כן</> : <>לא</>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    כינון אוטומטי
                                                </div>
                                                <div className="value">
                                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.offer && signingData.elementaryPolicy.offer.autodirection ? <>כן</> : <>לא</>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    נהיגה בשבת
                                                </div>
                                                <div className="value">
                                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.offer && signingData.elementaryPolicy.offer.driveInShabbat ? <>כן</> : <>לא</>}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>
                            <section className='with-top-border'>
                                <div className='section-title'>
                                    גביה
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                פרמיה לתשלום
                                            </div>
                                            <div className="value">
                                                ₪
                                                {signingData.netPremium}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מטבע
                                            </div>
                                            <div className="value">
                                                שקל
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                שיטת גביה
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מסלול גביה
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item parameter-item-payments">
                                        <div className="field">
                                            <div className="title">
                                                תשלומים
                                            </div>
                                            <div className="value">
                                                {signingData.numberOfPayments}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className='with-top-border'>
                                <div className='section-title'>
                                    פרטי חשבון
                                </div>

                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מספר חשבון
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                בנק
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                סניף
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                שם בעל החשבון
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מספר התחייבות
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className='with-top-border'>
                                <div className='section-title'>
                                    פרטי אשראי
                                </div>

                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מספר כרטיס
                                            </div>
                                            <div className="value">

                                                {signingData.vehiclePolicyType && signingData.vehiclePolicyType == 6 ?
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.compulsoryPaymentDetails ? signingData.elementaryPolicy.compulsoryPaymentDetails[0] : ""
                                                    :
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.comprehensivePaymentDetails ? signingData.elementaryPolicy.comprehensivePaymentDetails[0] : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                סוג
                                            </div>
                                            <div className="value">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                תוקף
                                            </div>
                                            <div className="value">
                                                {signingData.vehiclePolicyType && signingData.vehiclePolicyType == 6 ?
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.compulsoryPaymentDetails ? signingData.elementaryPolicy.compulsoryPaymentDetails[1] : ""
                                                    :
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.comprehensivePaymentDetails ? signingData.elementaryPolicy.comprehensivePaymentDetails[1] : ""
                                                }
                                                { }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                בעל הכרטיס
                                            </div>
                                            <div className="value">


                                                {signingData.vehiclePolicyType && signingData.vehiclePolicyType == 6 ?
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.compulsoryPaymentDetails && signingData.elementaryPolicy.compulsoryPaymentDetails.length == 6 ? signingData.elementaryPolicy.compulsoryPaymentDetails[4] + " - " + signingData.elementaryPolicy.compulsoryPaymentDetails[5] : ""
                                                    :
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.comprehensivePaymentDetails && signingData.elementaryPolicy.comprehensivePaymentDetails.length == 6 ? signingData.elementaryPolicy.comprehensivePaymentDetails[4] + " - " + signingData.elementaryPolicy.comprehensivePaymentDetails[5] : ""
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                ת.ז.
                                            </div>
                                            <div className="value">


                                                {signingData.vehiclePolicyType && signingData.vehiclePolicyType == 6 ?
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.compulsoryPaymentDetails && signingData.elementaryPolicy.compulsoryPaymentDetails.length == 6 ? signingData.elementaryPolicy.compulsoryPaymentDetails[3] : ""
                                                    :
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.comprehensivePaymentDetails && signingData.elementaryPolicy.comprehensivePaymentDetails.length == 6 ? signingData.elementaryPolicy.comprehensivePaymentDetails[3] : ""
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                CVV
                                            </div>
                                            <div className="value">
                                                {signingData.vehiclePolicyType && signingData.vehiclePolicyType == 6 ?
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.compulsoryPaymentDetails ? signingData.elementaryPolicy.compulsoryPaymentDetails[2] : ""
                                                    :
                                                    signingData && signingData.elementaryPolicy && signingData.elementaryPolicy.comprehensivePaymentDetails ? signingData.elementaryPolicy.comprehensivePaymentDetails[2] : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className='with-top-border'>
                                <div className='section-title'>
                                    שעבוד
                                </div>

                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                משעבד
                                            </div>
                                            <div className="value">
                                                {signingData.vehiclePolicyType != 6 && <>
                                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.involvedName ? signingData.elementaryPolicy.involvedName : ""}
                                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.involvedBank ? signingData.elementaryPolicy.involvedBank : ""}
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                    {signingData.elementaryPolicy && signingData.elementaryPolicy.involvedBank ?
                                        <>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        סניף
                                                    </div>
                                                    <div className="value">
                                                        {signingData.vehiclePolicyType != 6 && <>
                                                            {signingData.elementaryPolicy && signingData.elementaryPolicy.involvedBankBranch.split(',')[0] ? <>
                                                                {signingData.elementaryPolicy.involvedBankBranch.split(',')[0]}
                                                            </> : <></>}
                                                        </>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        רחוב ומספר
                                                    </div>
                                                    <div className="value">
                                                        {signingData.vehiclePolicyType != 6 && <>
                                                            {signingData.elementaryPolicy && signingData.elementaryPolicy.involvedBankBranch && signingData.elementaryPolicy.involvedBankBranch.split(',')[0] ? <>
                                                                {signingData.elementaryPolicy.involvedBankBranch.split(',')[1]}
                                                            </> : <></>}
                                                        </>}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    רחוב ומספר
                                                </div>
                                                <div className="value">
                                                    {signingData.vehiclePolicyType != 6 && <>
                                                        {signingData.involvedAddress ? <>
                                                            {signingData.elementaryPolicy.involvedAddress}
                                                        </> : <></>}
                                                    </>}
                                                </div>
                                            </div>
                                        </div>}
                                    <div className="parameter-item">

                                    </div>
                                    <div className="parameter-item">

                                    </div>
                                </div>

                            </section>
                        </div>
                    </div>
                    <div className='signing-details-left-side'>
                        <div className='white-block'>

                            {signingData.policyId && signingData?.policy?.customerId &&
                                <SignDocuments
                                    actionBtns={props.actionBtns}
                                    customerId={signingData?.policy?.customerId}
                                    relationId={signingData.policyId}
                                    retationType={2} //policy
                                    displayFile={(file: any) => setSelectedDocument(file)}
                                    showAddTreatmentPopup={(customerId: string, policyId: string, type: number) => props.onNewOrEditTreatment(customerId, policyId, type)}
                                />
                            }
                        </div>
                        <div className='white-block'>

                            <div className={`sue-tab-content`}>
                                {signingData.policy && signingData.policy.customer &&
                                    <Treatments
                                        actionBtns={props.actionBtns}
                                        relationId={signingData.policyId}
                                        loadData={props.loadTreatments}
                                        relationType={2}//policy
                                        config={{
                                            insuranceTypes: insuranceTypes,
                                            licenseTypes: licenseTypes,
                                            handlers: handlersList,
                                            genders: gendersList,
                                            insuranceCompanies: insuranceCompanyList,
                                            garages: garages,
                                            vehicleOwnerships: vehicleOwnerships,
                                            users: usersOptions,
                                            showAddTreatmentPopup: (customerId: string, policyId: string, type: number) => props.onNewOrEditTreatment(customerId, policyId, type),
                                            closeTab: () => closeWithoutSave(signingData.Id),
                                            showMessagePopup: (message: string) => showMessagePopup(message)

                                        }}
                                        showAddTreatmentPopup={props.config.showAddTreatmentPopup ? props.config.showAddTreatmentPopup : () => { }}
                                        customerId={signingData.policy && signingData.policy.customer ? signingData.policy.customerId : ''}
                                        customer={signingData.policy && signingData.policy.customer ? signingData.policy.customer : undefined}
                                        propTreatmentsList={signingData.treatments}
                                        insuranceCompanyId={signingData.policy ? signingData.policy.insuranceCompanyId : undefined}
                                        onSelectDocument={(document: any) => onSelectDocument(document)}
                                    />
                                }

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default SigningDetails;